import { render, staticRenderFns } from "./PurchasesSummary.vue?vue&type=template&id=c8a25320&scoped=true&"
import script from "./PurchasesSummary.vue?vue&type=script&lang=js&"
export * from "./PurchasesSummary.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesSummary.vue?vue&type=style&index=0&id=c8a25320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a25320",
  null
  
)

export default component.exports